(() => {
  const selector = '.product-template .product-option-item[role="button"]';
  document.addEventListener('keydown', event => {
    const option = event.target.closest(selector);
    if (!option || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    option.click();
  });
  const prepare = () => {
    document.querySelectorAll(selector).forEach(option => {
      option.setAttribute('aria-pressed', String(option.dataset.selected === 'true'));
    });
    const root = document.querySelector('.product-template .product-options');
    if (!root) return;
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.target.matches(selector)) {
          record.target.setAttribute('aria-pressed', String(record.target.dataset.selected === 'true'));
        }
      });
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['data-selected'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();
})();
